import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SidebarHeader from './components/SidebarHeader';
import DashboardContent from './components/inhalt_dashboard';
import KalenderApp from './components/calendarContent';
import EscrowDashboard from './components/EscrowDashboard';
import ContactsTable from './components/ContactsTable';
import PasswordProtection from './components/PasswordProtection';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const auth = localStorage.getItem('isAuthenticated');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  if (!isAuthenticated) {
    return <PasswordProtection onAuthenticate={setIsAuthenticated} />;
  }

  return (
    <Router>
      <div className="App">
        <SidebarHeader>
          <Routes>
            <Route path="/" element={<DashboardContent />} />
            <Route path="/calendar" element={<KalenderApp />} />
            <Route path="/escrows" element={<EscrowDashboard />} />
            <Route path="/contacts" element={<ContactsTable />} />
          </Routes>
        </SidebarHeader>
      </div>
    </Router>
  );
}

export default App;